<template>
	<div class="body">
		<div class="body-container" v-if="data">

			<div class="title-ctr">{{data.title}}</div>

			<div class="step-ctr">
				<div class="step-name">{{data.step}}</div>
				<div class="step-route" @click="clickRule(data.ruleRoute)">{{data.ruleRoute.title}}</div>
			</div>

			<div class="factor-ctr">
				<label class="factor-name">{{data.updateData.title}}</label>

				<el-input class="factor-input" v-model="updateFactor" @input="updateFactorChange" type="number"
					:step="step"></el-input>

				<label class="factor-note">调整区间：{{data.updateData.min}}-{{data.updateData.max}}</label>
			</div>

			<div class="factor-ctr">
				<label class="factor-name">{{data.outData.title}}</label>

				<el-input class="factor-input" v-model="outFactor" @input="outFactorChange" type="number"
					:step="step"></el-input>

				<label class="factor-note">调整区间：{{data.outData.min}}-{{data.outData.max}}</label>
			</div>

			<div class="factor-ctr">
				<label class="factor-name">{{data.flowData.title}}</label>

				<el-input class="factor-input" v-model="flowFactor" @input="flowFactorChange" type="number"
					:step="step"></el-input>

				<label class="factor-note">调整区间：{{data.flowData.min}}-{{data.flowData.max}}</label>
			</div>

			<div class="factor-ctr">
				<label class="factor-name">{{data.graduateData.title}}</label>

				<el-input class="factor-input" v-model="graduateFactor" @input="graduateFactorChange" type="number"
					:step="step"></el-input>

				<label class="factor-note">调整区间：{{data.graduateData.min}}-{{data.graduateData.max}}</label>
			</div>

			<div class="factor-ctr">
				<label class="factor-name">{{data.majorData.title}}</label>

				<el-button class="el-button--success select-major" type="primary" icon="el-icon-edit"
					@click="clickEditMajor">{{data.majorData.name}}</el-button>

				<label class="factor-note">{{data.majorData.tips}}</label>
			</div>

			<div class="table-title">分专业表</div>
			<el-table :data="majorTargetList" border stripe :span-method="spanMethod">
				<el-table-column label="专业" align="center" prop="major_name" />
				<el-table-column label="年份" align="center" prop="year" />
				<el-table-column label="招生数" align="center" prop="enroll_num" />
				<el-table-column label="毕业生数" align="center" prop="graduate_num" />
				<el-table-column label="供给数量" align="center" prop="supply_num" />
				<el-table-column label="权重" align="center" prop="weight" />
			</el-table>

			<div class="table-title">汇总表</div>
			<el-table :data="allList" border stripe>
				<el-table-column label="年份" align="center" prop="year" />
				<el-table-column label="招生数" align="center" prop="enroll_num" />
				<el-table-column label="毕业生数" align="center" prop="graduate_num" />
				<el-table-column label="供给数量" align="center" prop="supply_num" />
			</el-table>
		</div>
		
		<div class="tips">{{data.tips}}</div>

		<div class="action-ctr">
			<el-button type="primary" icon="el-icon-right" size='medium' @click="clickNext()"
				class="next-btn">下一步</el-button>
		</div>

		<el-dialog title="编辑专业" :visible.sync="showGroupMajorDialog" append-to-body v-if="showGroupMajorDialog"
			align="center" @close="onGroupDialogClosed">

			<div class="tab-ctr">
				<label v-for="(item,index) in groupAddList"
					:class="['tab-item', index == groupAddIndex ? 'tab-item-s' : '']" :key="index"
					@click="clickAddTab(index)">{{item.name}}</label>
			</div>

			<el-form :inline="true" align="left">
				<el-form-item label="专业大类">
					<el-select v-model="topMajor" placeholder="请输入关键字" class="select-group-width" filterable remote
						:clearable=true reserve-keyword :remote-method="loadGroupTopMajorList"
						@change="changeGroupTopMjor">
						<el-option v-for="item in topMajorList" :key="item.code" :label="item.name" :value="item.code">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="专业类">
					<el-select v-model="parentMajor" placeholder="请输入关键字" class="select-group-width" :clearable=true
						filterable remote reserve-keyword :remote-method="loadGroupParentMajorList"
						@change="changeGroupParentMajor">
						<el-option v-for="item in parentMajorList" :key="item.code" :label="item.name"
							:value="item.code">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="专业">
					<el-select v-model="major" placeholder="请输入关键字" class="select-group-width" :clearable=true
						filterable remote reserve-keyword :remote-method="loadGroupMajorList"
						@change="changeGroupMajor">
						<el-option v-for="item in majorList" :key="item.code" :label="item.name" :value="item.code">
						</el-option>
					</el-select>
				</el-form-item>
			</el-form>

			<div class="data-table">
				<el-table :data="groupDataList" border>
					<el-table-column prop="name" label="专业" align="center"></el-table-column>
					<el-table-column prop="topMajor" label="专业大类" align="center"></el-table-column>
					<el-table-column prop="parentMajor" label="专业类" align="center"></el-table-column>
					<el-table-column label="操作" align="center">
						<template v-slot="{ row }">
							<el-button type="primary" size="small" @click="clickAddGroupMajor(row.code)"
								v-if="row.isAdd != 1">添加</el-button>
							<el-button type="warning" size="small" @click="clickRemoveGroupMajor(row.code)"
								v-else>移除</el-button>
						</template>
					</el-table-column>

				</el-table>

				<div class="pagination">
					<pagination v-show="total>0" :total="total" :page.sync="groupQueryParams.page"
						:limit.sync="groupQueryParams.pageSize" @pagination="queryGroupMajorData" />
				</div>
			</div>
			<div slot="footer" class="dialog-footer" align="center">
				<el-button type="primary" @click="clickCloseGroupDialog()">确 定</el-button>
			</div>
		</el-dialog>
		<el-dialog title="原理介绍" :visible.sync="showIntroDialog" append-to-body v-if="showIntroDialog" align="center">

			<div class="rich-ctr">
				<div class="rich-value" v-html="introDialog.value"></div>
			</div>


			<div slot="footer" class="dialog-footer" align="center">
				<el-button type="primary" @click="clickCloseIntroDialog()">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getMatchCalcuPage,
		calcuFactorChange,
		getMatchCalcuMajor,
		addMatchCalcuMajor,
		removeMatchCalcuMajor
	} from "@/api/service"

	import {
		getGroupTopMajorList,
		getGroupParentMajorList,
		getGroupMajorList,
	} from "@/api/matrix"


	import {
		getSpanMap,
		isEmpty
	} from "@/utils/util"

	import {
		Notification,
		Message,
		Loading
	} from 'element-ui'

	import {
		parse,
		handleProtocal,
		handleRouteProtocal
	} from "@/utils/protocal"

	export default {
		name: "Famous",
		data() {
			return {
				params: {
					page: 1,
					pageSize: 20
				},
				spanMap: {},
				updateFactor: '',
				outFactor: '',
				flowFactor: '',
				graduateFactor: '',
				data: null,
				list: null,
				step: 0.01,
				showGroupMajorDialog: false,
				groupAddList: [{
						'name': '未添加',
						'value': 2
					},
					{
						'name': '已添加',
						'value': 1
					},
				],
				groupAddState: 2,
				groupAddIndex: 0,
				groupQueryParams: {
					page: 1,
					pageSize: 10
				},
				groupDataList: [],
				total: 0,
				topMajorList: [],
				topMajor: undefined,
				parentMajorList: [],
				parentMajor: undefined,
				majorList: [],
				major: undefined,
				showIntroDialog: false,
				introDialog: null,
				variableType: {
					File: 2,
					Rich: 3
				}
			}
		},
		created() {
			this.initPageData();
		},

		methods: {
			initPageData() {
				this.params['id'] = this.$route.query.id;
				this.requestData();
			},

			buildParams() {
				this.params['updateFactor'] = this.updateFactor;
				this.params['outFactor'] = this.outFactor;
				this.params['flowFactor'] = this.flowFactor;
				this.params['graduateFactor'] = this.graduateFactor;
				return this.params;
			},

			requestData() {
				getMatchCalcuPage(this.buildParams()).then(res => {
					let realData = res.data;
					this.updateFactor = realData.updateData.value;
					this.outFactor = realData.outData.value;
					this.flowFactor = realData.flowData.value;
					this.graduateFactor = realData.graduateData.value;
					this.data = realData;
					this.allList = res.data.allList;
					this.majorTargetList = res.data.majorTargetList;
					this.spanMap = getSpanMap(this.majorTargetList, ['major_name'])
				});
			},

			clickNext() {
				let path = '/compare?id=' + this.params['id']
				this.$router.push(path);
			},

			clickRule(route) {
				if (route.type == this.variableType.File) {
					let path = route.path;
					window.open(path, '_blank')
				} else if (route.type == this.variableType.Rich) {
					this.showIntroDialog = true;
					this.introDialog = route;
				}
			},

			clickCloseIntroDialog() {
				this.showIntroDialog = false;
			},

			spanMethod({
				row,
				column,
				rowIndex
			}) {
				const colProp = column.property // 当前列字段名
				if (this.spanMap[colProp]) {
					const rowspan = this.spanMap[colProp][rowIndex]
					return {
						rowspan,
						colspan: rowspan === 0 ? 0 : 1
					}
				}
				return {
					rowspan: 1,
					colspan: 1
				}
			},

			updateFactorChange(num) {
				this.updateFactor = this.getLimitValue(num, this.data.updateData.min, this.data.updateData.max)
				this.onFactorChange();
			},

			outFactorChange(num) {
				this.outFactor = this.getLimitValue(num, this.data.outData.min, this.data.outData.max)
				this.onFactorChange();
			},

			flowFactorChange(num) {
				this.flowFactor = this.getLimitValue(num, this.data.flowData.min, this.data.flowData.max)
				this.onFactorChange();
			},

			graduateFactorChange(num) {
				this.graduateFactor = this.getLimitValue(num, this.data.graduateData.min, this.data.graduateData.max)
				this.onFactorChange();
			},

			getLimitValue(num, min, max) {
				// 最小值限制
				if (num < min) {
					num = min;
				}

				// 最大值限制
				if (num > max) {
					num = max;
				}

				return num;
			},

			onFactorChange() {
				calcuFactorChange(this.buildParams()).then(res => {
					this.allList = res.data.allList;
					this.majorTargetList = res.data.majorTargetList;
				})
			},


			clickAddTab(index) {
				this.topMajor = '';
				this.parentMajor = '';
				this.major = '';

				this.parentMajorList = []
				this.majorList = [];

				this.groupQueryParams.page = 1;
				this.groupAddIndex = index;
				this.groupAddState = this.groupAddList[index]['value']
				this.queryGroupMajorData();
			},

			changeGroupTopMjor(value) {
				this.parentMajor = ''
				this.majorList = []
				this.major = ''
				this.groupQueryParams.page = 1;
				this.loadGroupParentMajorList('');
				this.queryGroupMajorData();
			},

			changeGroupParentMajor(value) {
				this.groupQueryParams.page = 1;
				this.loadGroupMajorList('');
				this.queryGroupMajorData();
			},

			changeGroupMajor(value) {
				this.groupQueryParams.page = 1;
				this.queryGroupMajorData();
			},

			clickEditMajor() {
				this.showGroupMajorDialog = true;
				this.groupDataList = [];
				this.topMajor = '';
				this.parentMajor = '';
				this.major = '';
				this.parentMajorList = []
				this.majorList = [];
				this.groupQueryParams.page = 1;
				this.groupAddIndex = 0;
				this.groupAddState = 2;
				this.loadGroupTopMajorList();
				this.queryGroupMajorData();
			},

			clickCloseGroupDialog() {
				this.showGroupMajorDialog = false;
				this.onGroupDialogClosed();
			},

			loadGroupTopMajorList(query) {
				getGroupTopMajorList({
					name: query
				}).then(res => {
					this.topMajorList = res.data.topMajorList;
				});
			},

			queryGroupMajorData() {
				this.groupQueryParams.id = this.params.id;
				this.groupQueryParams.top_code = this.topMajor;
				this.groupQueryParams.parent_code = this.parentMajor;
				this.groupQueryParams.code = this.major;
				this.groupQueryParams.isAdd = this.groupAddState;
				getMatchCalcuMajor(this.groupQueryParams).then(res => {
					this.groupDataList = res.data.list;
					this.total = res.data.pageData.totalCount;
				});
			},

			loadGroupParentMajorList(query) {
				getGroupParentMajorList({
					name: query,
					top_code: this.topMajor
				}).then(res => {
					this.parentMajorList = res.data.parentMajorList;
					console.log('clear major--------')
				});
			},

			loadGroupMajorList(query) {
				console.log('loadMajorList query', query)
				getGroupMajorList({
					name: query,
					top_code: this.topMajor,
					parent_code: this.parentMajor
				}).then(res => {
					this.majorList = res.data.majorList;
					this.major = ''
				});
			},

			onGroupDialogClosed() {
				this.requestData();
			},

			clickAddGroupMajor(code) {
				let params = {
					'id': this.params.id,
					'code': code
				}
				addMatchCalcuMajor(params).then(res => {
					this.queryGroupMajorData();
				});
			},

			clickRemoveGroupMajor(code) {
				let params = {
					'id': this.params.id,
					'code': code
				}
				removeMatchCalcuMajor(params).then(res => {
					this.queryGroupMajorData();
				});
			},
		}
	}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
	@use "calcu.scss";
</style>